import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from 'yup';
import { Button, Col, Form, Row } from "react-bootstrap";
import { CircularProgress, Grid } from "@mui/material";
import { TbDatabaseEdit } from "react-icons/tb";
import { IoIosAdd, IoMdArrowBack } from "react-icons/io";
import { createUser, getSingleUserDetails, updateUserDetails } from "../../api/context/users";
import { getAllRoles } from "../../api/context/roles";
import { checkUserPermissions } from "../../helpers/permission";
import toast from "react-hot-toast";
import { getRolesPaginate } from "../../api/context/manufacturer";
import AsyncSelect from 'react-select/async';

const customStyles = {
    control: (provided) => ({
        ...provided,
        border: " 1px solid #a7a7a7",
        padding: '6px',
    }),
};

export const CreateUser = () => {

    const navigate = useNavigate();
    const { id } = useParams()
    let [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState([]);

    const validationSchema = yup.object().shape({
        firstName: yup.string('').required('Required'),
        // lastName: yup.string('').required('Required'),
        roleId: yup.string('').required('Required'),
        email: yup.string('').email().required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            userId: '',
            firstName: '',
            lastName: '',
            roleId: '',
            selectedRole: '',
            email: '',
            isDoctor: ''
        },
        validationSchema: validationSchema,
        validate: async (values) => {
            const errors = {};
            if (!values.selectedRole) {
                errors.selectedRole = "Role is required";
            }
            return errors;
        },
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            try {
                if (id) {
                    updateUserDetails(values)((response) => {
                        if (response && response?.data?.statusCode == 200) {
                            setLoading(false);
                            resetForm();
                            toast.success("User Updated Successfully")
                            navigate("/users");
                        } else {
                            setLoading(false);
                            toast.error(response?.data?.message);

                        }
                    })

                }
                else {
                    delete values.userId
                    createUser(values)((response) => {
                        if (response && response?.data?.statusCode == 200) {
                            setLoading(false);
                            resetForm();
                            toast.success("User Created Successfully")
                            navigate("/users");
                        } else {
                            setLoading(false);
                            toast.error(response?.data?.message);

                        }
                    })
                }
            } catch (error) {
                console.error(error);

                setLoading(false);
            }
        },
    });

    let typingTimer;
    const loadOptions = inputValue => {
        return new Promise((resolve, reject) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 3) {
                    getRolesPaginate({ page: 1, limit: 10, search: inputValue })(response => {
                        console.log(response)
                        if (response?.statusCode == 200) {
                            console.log(response?.results)
                            resolve(response?.results);
                            setRoles(response?.results)
                        } else {
                        }
                    })
                }
                else {
                    resolve([]);
                }

            }, 300);
        });
    };

    const onChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            roleId: selectedOption ? selectedOption.value : '',
            selectedRole: selectedOption,
        });
    };


    useEffect(() => {
        if (id) {
            setLoading(true)
            getUserDetail()
        }
    }, [id])

    useEffect(() => {
        getRolesPaginate({ page: 1, limit: 10, search: '' })(response => {
            if (response?.statusCode == 200) {
                console.log(response?.results)
                setRoles(response?.results)
            } else {
            }
        })
        // getAllRoles()((response) => {
        //     if (response?.data?.statusCode == 200) {
        //         setRoles(response?.data?.data?.roles);

        //     } else {

        //     }
        // })
    }, [])

    const getUserDetail = async () => {
        getSingleUserDetails({ userId: id })(async (response) => {
            if (response?.data?.statusCode == 200) {
                const user = response.data.data?.user
                formik.setValues((prevState) =>
                ({
                    ...prevState,
                    userId: id,
                    firstName: user?.firstName ? user?.firstName : '',
                    lastName: user?.lastName ? user?.lastName : '',
                    email: user?.email ? user?.email : '',
                    selectedRole: {
                        value: user?.roleId ? user?.roleId : '',
                        label: user?.userType ? user?.userType : ''
                    },
                    roleId: user?.roleId ? user?.roleId : '',
                    isDoctor: user?.isDoctor ? user?.isDoctor : false,
                }))
                setLoading(false)
            } else {
                setLoading(false)
            }
        })
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center">
                        <Link to='/users' className='back_btn_wrap'>
                            <IoMdArrowBack className='icon' />
                        </Link>
                        <h4 className="mb-sm-0">{id ? 'Edit' : 'Create'} User</h4>
                    </div>
                </div>
            </div>
            <div className="pe-2">
                <Form >
                    <div className="mb-3">
                        <div className="create-form-card">
                            <Row>
                                <div className="col-lg-6 col-md-12">
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter first name"
                                            name='firstName'
                                            onChange={(e) => formik.setFieldValue('firstName', e.target.value.trimStart())}
                                            value={formik.values.firstName}
                                            isInvalid={formik.touched.firstName && formik.errors.firstName}
                                            error={formik.errors.firstName}

                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.firstName}</Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter last name"
                                            name='lastName'
                                            onChange={(e) => formik.setFieldValue('lastName', e.target.value.trimStart())}
                                            value={formik.values.lastName}
                                            isInvalid={formik.touched.lastName && formik.errors.lastName}
                                            error={formik.errors.lastName}

                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.lastName}</Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter email"
                                            name='email'
                                            onChange={formik.handleChange}
                                            value={formik.values.email}
                                            isInvalid={formik.touched.email && formik.errors.email}
                                            error={formik.errors.email}

                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.email}</Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <Form.Group>
                                        <Form.Label>Role</Form.Label>
                                        <AsyncSelect
                                            loadOptions={loadOptions}
                                            defaultOptions={roles}
                                            classNamePrefix="select"
                                            isClearable={true}
                                            placeholder={'Search Roles'}
                                            onChange={onChange}
                                            value={formik.values.selectedRole}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: "0 10px 10px 10px",
                                                colors: {
                                                    ...theme.colors,
                                                    primary: '#779be1',
                                                },
                                            })}
                                            styles={customStyles}
                                        />
                                        {/* <Form.Select
                                            onChange={formik.handleChange}
                                            name='roleId'
                                            value={formik.values.roleId}
                                            isInvalid={formik.touched.roleId && formik.errors.roleId}
                                            error={formik.errors.roleId}
                                        >
                                            <option value={''} disabled selected>
                                                Select an option
                                            </option>
                                            {roles?.map((item, i) => {
                                                return (
                                                    <option id={i} value={item.id}>
                                                        {item.name}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select> */}
                                        {/* <Form.Control.Feedback type="invalid">{formik.errors.roleId}</Form.Control.Feedback> */}
                                        <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.selectedRole && formik.errors.selectedRole}</div>

                                    </Form.Group>
                                </div>

                            </Row>
                        </div>
                    </div>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className='create-btn-grid'>
                        <Button className='save_btn' onClick={formik.handleSubmit} disabled={loading}>
                            <div class="d-flex">
                                <div class="flex-grow-1">
                                    {loading ? "Loading" : id ? "Update" : "Save"}
                                </div>
                            </div>
                        </Button>
                        {/* <button class="btn btn-custom-primary btn-label" onClick={formik.handleSubmit}>
                            <div class="d-flex">
                                <div class="flex-shrink-0">
                                    {loading ?
                                        <div className="ri-user-smile-line label-icon align-middle fs-14 me-2" style={{ color: "white", height: '100%' }}>

                                            <CircularProgress size={20} style={{ color: "white" }} />

                                        </div>
                                        :
                                        <div className="ri-user-smile-line label-icon align-middle fs-14 me-2" style={{ height: '100%' }}>
                                            {id ?
                                                <TbDatabaseEdit size={20} />
                                                :
                                                <IoIosAdd size={20} />
                                            }
                                        </div>
                                    }
                                </div>
                                <div class="flex-grow-1">
                                    {loading ? "Loading" : id ? "Update" : "Save"}
                                </div>
                            </div>
                        </button> */}
                    </Grid>

                </Form>
            </div>

        </>
    );
};
